<template>
  <div class="container">
    <div class="block1">
      <div class="block1-1">
        <span>{{ $t("common.totalBalance") }}</span>
        <span style="font-size:8rem;">{{data.totalBalance}} <span style="font-size:4rem;">USDT</span></span>
        <img src="../assets/images/1-1.png">
      </div>
      <div class="block1-2">
        <img class="horn" src="../assets/images/horn.png">
        <div style="flex:1;margin-left:2.5rem;">
          <van-notice-bar
            :text="rollingNotification"
          />
        </div>
      </div>
    </div>
    <div class="block2" @click="$router.push('/notification')">
      <img class="q" src="../assets/images/q.png">
      <div class="block2-2">
        <span class="text1">{{ $t("homePage.theCommonProblem") }}</span>
        <span class="text2">{{ $t("homePage.latestAnnouncement") }}</span>
      </div>
    </div>
    <img class="lingdan" src="../assets/images/lingdan.920940d0.png" @click="notificationVisible = true">
    <div class="block6">
      <span class="block6title">{{ $t("homePage.block6title") }}</span>
      <div class="profit">
        <div>
          <span id="accumulatedProfit">{{platformData.accumulatedProfit}}</span>
          <span>{{ $t("homePage.accumulatedProfit") }}</span>
        </div>
        <img src="../assets/images/data-1.png">
      </div>
      <div class="membership">
        <div>
          <span id="membership">{{platformData.membership}}</span>
          <span>{{ $t("homePage.membership") }}</span>
        </div>
        <img src="../assets/images/vip-1.png">
      </div>
    </div>
    <div class="block4">
      <div class="block4-1">
        <div class="block4-n-1">
          <img src="../assets/images/1-3.png">
          <div>
            <span>{{ $t("common.wallet") }}</span>
            <span>{{ $t("common.account") }}</span>
          </div>
        </div>
        <div class="block4-n-2">
          <span>USDT</span>
          <span>{{data.totalBalance}}</span>
          <span>≈${{data.totalBalance}}</span>
        </div>
      </div>
      <div class="block4-2">
        <div class="block4-n-1">
          <img src="../assets/images/1-2.png">
          <div>
            <span>{{ $t("common.promotion") }}</span>
            <span>{{ $t("common.account") }}</span>
          </div>
        </div>
        <div class="block4-n-2">
          <span>USDT</span>
          <span>{{data.promotionBalance}}</span>
          <span>≈${{data.promotionBalance}}</span>
        </div>
      </div>
    </div>
    <div class="block3">
      <div class="item" @click="$router.push('/deposit')">
        <img class="icon-box" src="../assets/images/b3-i1.png">
        <span>{{ $t("common.deposit") }}</span>
      </div>
      <div class="item" @click="$router.push('/withdrawal')">
        <img class="icon-box" src="../assets/images/b3-i2.png">
        <span>{{ $t("common.withdrawal") }}</span>
      </div>
      <div class="item" @click="$router.push('/share')">
        <img class="icon-box" src="../assets/images/b3-i3.png">
        <span>{{ $t("common.share") }}</span>
      </div>
      <div class="item" @click="$router.push('/team')">
        <img class="icon-box" src="../assets/images/b3-i4.png">
        <span>{{ $t("common.team") }}</span>
      </div>
      <div class="item" @click="$router.push('/task')">
        <img class="icon-box" src="../assets/images/b3-i5.png">
        <span>{{ $t("common.task") }}</span>
      </div>
      <div class="item">
        <img class="icon-box" src="../assets/images/b3-i6.png" @click="logout">
        <span>{{ $t("common.logout") }}</span>
      </div>
    </div>
    <div class="block5">
      <span class="block5title">{{ $t("homePage.block5title") }}</span>
      <img src="../assets/images/1-4.png">
      <span class="block5desc">{{ $t("homePage.block5desc") }}</span>
      <van-button round color="linear-gradient(to right, #F0A500, #E45826)" @click="$router.push('/trading')">
        {{ $t("common.details") }}
      </van-button>
    </div>
    <div class="block7">
      <span class="about">{{ $t("common.aboutUs") }}</span>
      <span class="block7title">{{ $t("homePage.block7title") }}</span>
      <img src="../assets/images/mining.png" style="height: 83rem">
      <span class="block7desc">{{ $t("homePage.block7desc") }}</span>
      <span class="partners">{{ $t("common.globalPartners") }}</span>
      <div class="logos">
        <a href="https://wazirx.com/" target="_blank"><img src="../assets/images/partners/1.png"></a>
        <a href="https://coindcx.com/" target="_blank"><img src="../assets/images/partners/2.png"></a>
        <a href="https://www.genesis-mining.com/" target="_blank"><img src="../assets/images/partners/3.png"></a>
        <a href="https://www.bitmain.com/" target="_blank"><img src="../assets/images/partners/4.png"></a>
        <a href="https://www.binance.org/" target="_blank"><img src="../assets/images/partners/5.png"></a>
        <a href="https://www.coinmint.one/" target="_blank"><img src="../assets/images/partners/6.png"></a>
      </div>
    </div>
    <van-overlay :show="notificationVisible">
      <div class="wrapper">
        <div class="center-box" @click.stop>
          <div class="title">{{(notifications.length && notifications[notificationsIndex].title) || 'None'}}</div>
          <div class="content">
            <div style="font-size:3.668rem;overflow-x: hidden;word-break: break-all;text-align: left;text-indent: 4rem;" v-html="(notifications.length && notifications[notificationsIndex].content) || 'None'">
            </div>
          </div>
          <div class="foot">
            <van-button class="btn" type="default" size="small" :disabled="notificationsIndex === 0" @click="notificationsIndex = notificationsIndex - 1">{{ $t("common.previous") }}</van-button>
            <van-button class="btn" type="warning" size="small" @click="notificationVisible = false">{{ $t("common.close") }}</van-button>
            <van-button class="btn" type="default" size="small" :disabled="notifications.length === 0 || notificationsIndex === (notifications.length - 1)" @click="notificationsIndex = notificationsIndex + 1">{{ $t("common.next") }}({{notificationsIndex + 1}}/{{notifications.length}})</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import CountUp from 'countup';
export default {
  name: 'home',
  data() {
    return {
      notificationVisible: false,
      data: {
        totalBalance: '0.00',
        promotionBalance: '0.00',
        rollingNotification_mode: 'fixed',
        rollingNotification: '',
        notifications: []
      },
      notifications: [],
      notificationsIndex: 0,
      oldplatformData: {
        accumulatedProfit: '0.000000',
        membership: 0
      },
      platformData: {
        accumulatedProfit: '0.000000',
        membership: 0
      },
      timer: null,
      countupOpts: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.'
      },
    }
  },
  beforeMount() {
    this.token = localStorage.getItem('token');
    this._fetch();
  },
  mounted() {
    this._fetchdata();
    this.timer = setInterval(() => {
      this._fetchdata();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    _fetch() {
      this.apiV1({
          method: 'get',
          url: '/home',
          headers: {'Authorization': this.token}
      }).then(response => {
          const { success, data } = response.data;
          if (success) {
              this.data = data;
              let readNotifications = localStorage.getItem('readNotifications');
              if (!readNotifications) {
                readNotifications = [];
              } else {
                readNotifications = JSON.parse(readNotifications);
              }
              this.notifications = data.notifications.filter(elem => !readNotifications.includes(elem.id)).map(elem => {
                  elem.content = elem.content.replace(/\r?\n/g, '<br>');
                  elem.content = elem.content.replace(/\s/g, '&nbsp;');
                  return elem;
              });
              readNotifications.push(...this.notifications.map(elem => elem.id));
              localStorage.setItem('readNotifications', JSON.stringify(readNotifications));
              this.notificationVisible = !!this.notifications.length;
          }
      })
    },
    _fetchdata() {
      this.apiV1({
          method: 'get',
          url: '/platformData',
          headers: {'Authorization': this.token}
      }).then(response => {
          const { success, data } = response.data;
          if (success) {
              this.oldplatformData = Object.assign({}, this.platformData);
              this.platformData = data;
          }
      }).finally(() => this.countupStart());
    },
    logout() {
      localStorage.removeItem('addr');
      localStorage.removeItem('token');
      location.reload();
    },
    countupStart() {
        const accumulatedProfit = new CountUp('accumulatedProfit', this.oldplatformData.accumulatedProfit, this.platformData.accumulatedProfit, 6, 2, this.countupOpts);
        const membership = new CountUp('membership', this.oldplatformData.membership, this.platformData.membership, 0, 2, this.countupOpts);
        setTimeout(() => {
            if (!accumulatedProfit.error) accumulatedProfit.start();
            if (!membership.error) membership.start();
        }, 200);
    }
  },
  computed: {
    rollingNotification() {
      const { rollingNotification_mode, rollingNotification } = this.data;
      if (rollingNotification_mode === 'fake') {
        return rollingNotification.map(elem => `${elem.phone} ${this.$t(elem.type ? "homePage.zl":"homePage.tzl")} ${elem.amount} USDT.`).join(' ');
      }
      return rollingNotification;
    }
  }
}
</script>
<style scoped lang="less">
.container {
  padding: @nav-bar-height 4rem @tabbar-height;
}
.block1 {
  display: flex;
  flex-direction: column;
  margin-top: 18rem;
  color: #fff;
  height: 48rem;
  text-shadow: 0.267rem 0.267rem 0.267rem #cbc3c3;
  // background: linear-gradient(to bottom, @app-theme-color1, @app-theme-color4);
  border-radius: 4rem;
  box-shadow: 0.6rem 1.2rem 2.5rem 0 @app-theme-color1;
  .block1-1 {
    position: relative;
    height: 60%;
    padding: 4rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-weight: bold;
    z-index: 1;
    img {
      position: absolute;
      width: 60rem;
      top: -8rem;
      right: -4rem;
      z-index: -1;
    }
  }
  .block1-2 {
    z-index: 1;
    flex: 1;
    padding: 0 4rem;
    background: @app-theme-color4;
    border-radius: 4rem;
    display: flex;
    align-items: center;
    .horn {
      padding: 2rem;
      border-radius: 4rem;
      // background: linear-gradient(to bottom, @app-theme-color1, @app-theme-color4);
      width: 4rem;
      height: 4rem;
      box-shadow: 0.6rem 1rem 2rem 0 @app-theme-color1;
    }
  }
}
.block2 {
  display: flex;
  margin-top: 5.5rem;
  .q {
    padding: 3rem;
    border-radius: 5.25rem;
    // background: linear-gradient(to bottom, @app-theme-color1, @app-theme-color4);
    width: 4.5rem;
    height: 4.5rem;
    box-shadow: 0.6rem 1.2rem 2.5rem 0 @app-theme-color1;
  }
  .block2-2 {
    margin-left: 6rem;
    display: flex;
    flex-direction: column;
    .text1 {
      color: @app-theme-color4;
    }
    .text2 {
      color: @app-theme-color1;
    }
  }
}
.lingdan {
  width: 18.667rem;
  height: 18.667rem;
  right: 4.267rem;
  top: 53%;
  transform: translateY(-50%);
  z-index: 99;
  position: fixed;
}
.block3 {
  display: flex;
  flex-wrap: wrap;
  margin-top: 6rem;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 33.33%;
    height: 24rem;
    justify-content: space-around;
    .icon-box {
      width: 10rem;
      height: 10rem;
      border-radius: 4rem;
      padding: 2rem;
      box-shadow: 0.6rem 1rem 2rem 0 @app-theme-color1;
    }
  }
}
.block4 {
  margin-top: 6rem;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  img {
    width: 16rem;
    height: 16rem;
  }
  .block4-1, .block4-2 {
    width: 34rem;
    // background: linear-gradient(to top, @app-theme-color4, @app-theme-color1);
    border-radius: 6rem;
    padding:  4rem;
    box-shadow: 0.6rem 1rem 2rem 0 @app-theme-color1;
    .block4-n-1 {
      display: flex;
      margin-bottom: 4rem;
      div {
        margin-left: 0.667rem;
        display: flex;
        flex-direction: column;
      }
    }
    .block4-n-2 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      span:nth-child(1) {
        font-size: 3.2rem;
        display: inline-block;
        padding: 0 1rem;
        background: @app-theme-color2;
        border-radius: 2.5rem;
      }
      span:nth-child(3) {
        font-size: 3.2rem;
      }
    }
  }
}
.block5 {
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  padding: 4rem 3.467rem;
  border: 0.267rem solid;
  border-radius: 4rem;
  img {
    height: 52rem;
  }
  .block5title {
    font-size: 4.8rem;
    font-weight: bold;
  }
  .block5desc {
    font-size: 3.888rem;
    margin-bottom: 3.888rem;
  }
}
.block6 {
  display: flex;
  flex-direction: column;
  margin-top: 8rem;
  color: #fff;
  font-size: 5.067rem;
  .block6title {
    font-weight: bold;
  }
  .profit, .membership {
    display: flex;
    padding: 2rem 4rem;
    background: linear-gradient(to left, @app-theme-color4, @app-theme-color1);
    border-radius: 4rem;
    margin: 2rem 0;
    justify-content: space-between;
    align-items: center;
    >div {
      display: flex;
      flex-direction: column;
      span:nth-child(1) {
        font-weight: bold;
      }
      span:nth-child(2) {
        font-size: 3.2rem;
        color: @app-theme-color4;
      }
    }
    img {
      width: 16.88rem;
    }
  }
}
.block7 {
  margin: 4rem 0 10rem;
  display: flex;
  flex-direction: column;
  padding: 8rem 3.467rem 3.888rem;
  border: 0.267rem solid;
  border-radius: 4rem;
  .about {
    font-size: 3.467rem;
  }
  .block7title, .partners {
    font-size: 4.8rem;
    font-weight: bold;
  }
  .block7desc {
    font-size: 3.888rem;
    margin-bottom: 3.888rem;
  }
  .partners {
    margin: 4rem 0;
  }
  .logos {
    display: flex;
    flex-wrap: wrap;
    a {
      display: inline-block;
      width: 33.3%;
      img {
        width: 100%;
      }
    }
  }
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .center-box {
      width: 80rem;
      border-radius: 3.888rem;
      display: flex;
      background-color: @app-theme-color4;
      border: 0.667rem solid @app-theme-color1;
      flex-direction: column;
      text-align: center;
      .title {
        padding: 2.5rem;
        font-size: 4.8rem;
      }
      .content {
        background-color: #fff;
        margin: 0 1.6rem;
        border-radius: 2.133rem;
        border: 0.267rem solid @app-theme-color1;
        height: 85rem;
        overflow: auto;
        padding: 2.333rem;
        font-size: 1.867rem;
      }
      .foot {
        padding: 1.33rem;
        .btn + .btn {
          margin-left: 4rem;
          width: 20rem;
        }
      }
    }
}
</style>
